// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.36842 3H14.6316V21H9.36842V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2 9H7.26316V21H2V9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 11H16.7368V21H22V11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-leaderboard-filled')
export default class LeaderboardFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'leaderboard-filled',
    }
  }
}
